import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

@Component({
  selector: 'ts-admin-override-badge',
  templateUrl: './admin-override-badge.component.html',
  imports: [CommonModule, TranslationPipe]
})
export class AdminOverrideBadgeComponent {}
